export default function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen text-[#171512]">
      <header className="border-b border-[#171512]/10">
        <div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-6">
          <a href="/" className="font-serif text-2xl italic leading-none text-[#171512]">
            nostos
          </a>
          <div className="flex items-center gap-5">
            <a
              data-testid="legal-back-link"
              href="/"
              className="hidden font-mono text-[11px] uppercase tracking-[0.22em] text-[#171512]/50 transition-colors duration-200 hover:text-[#B9822E] sm:block"
            >
              back to nostos.in
            </a>
            <a
              data-testid="legal-join-button"
              href="/#waitlist"
              className="rounded-full bg-[#171512] px-4 py-2 font-mono text-[11px] font-medium uppercase tracking-[0.16em] text-[#F8F4ED] transition-colors duration-200 hover:bg-[#F5C7D4] hover:text-[#171512]"
            >
              join now
            </a>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="font-display text-4xl font-medium leading-[1.05] tracking-tight text-[#171512] sm:text-5xl">
          {title}
        </h1>
        {updated && (
          <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.22em] text-[#171512]/50">{updated}</p>
        )}
        <div className="mt-12 space-y-10 text-sm leading-[1.85] text-[#171512]/70 sm:text-base">
          {children}
        </div>
      </main>
    </div>
  );
}
